import React from 'react'
import App from './App'
import { ContextProvider } from '@monorepo/service'
import { ApmProvider } from '@monorepo/service'
import { GeoRuntimeProvider } from '../../geo/context'
import { TranslationProvider } from '../../i18n/context'

const Page = () => (
  <ApmProvider>
    <ContextProvider>
      <GeoRuntimeProvider>
        <TranslationProvider>
          <App />
        </TranslationProvider>
      </GeoRuntimeProvider>
    </ContextProvider>
  </ApmProvider>
)

export default Page
